"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import { ApiProfileProxyAction } from "@/generated/models/ApiProfileProxyAction";
import CommonTimeSelect from "@/components/utils/time/CommonTimeSelect";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useMutation } from "@tanstack/react-query";
import { commonApiPut } from "@/services/api/common-api";
import ProxyCreateActionConfigEndTimeSwitch from "@/components/user/proxy/proxy/create-action/config/ProxyCreateActionConfigEndTimeSwitch";
import { Time } from "@/helpers/time";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import { ApiUpdateProxyActionRequest } from "@/generated/models/ApiUpdateProxyActionRequest";
export default function ProfileProxyEndTimeEdit(t0) {
  const $ = _c(55);
  const {
    profileProxy,
    profileProxyAction,
    setViewMode
  } = t0;
  const {
    requestAuth,
    setToast
  } = useContext(AuthContext);
  const {
    onProfileProxyModify
  } = useContext(ReactQueryWrapperContext);
  const [isEndTimeDisabled, setIsEndTimeDisabled] = useState(!profileProxyAction.end_time);
  const [endTime, setEndTime] = useState(profileProxyAction.end_time);
  let t1;
  if ($[0] !== endTime || $[1] !== profileProxyAction.end_time) {
    t1 = () => {
      if (profileProxyAction.end_time === endTime) {
        return false;
      }
      if (endTime && endTime < Time.currentMillis()) {
        return false;
      }
      return true;
    };
    $[0] = endTime;
    $[1] = profileProxyAction.end_time;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getIsChangedAndValid = t1;
  const [isChangedAndValid, setIsChangedAndValid] = useState(getIsChangedAndValid());
  let t2;
  if ($[3] !== getIsChangedAndValid) {
    t2 = () => setIsChangedAndValid(getIsChangedAndValid());
    $[3] = getIsChangedAndValid;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== endTime || $[6] !== profileProxyAction.end_time) {
    t3 = [endTime, profileProxyAction.end_time];
    $[5] = endTime;
    $[6] = profileProxyAction.end_time;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  const [submitting, setSubmitting] = useState(false);
  let t4;
  if ($[8] !== profileProxy || $[9] !== profileProxyAction.id) {
    t4 = async body => await commonApiPut({
      endpoint: `proxies/${profileProxy.id}/actions/${profileProxyAction.id}`,
      body
    });
    $[8] = profileProxy;
    $[9] = profileProxyAction.id;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== onProfileProxyModify || $[12] !== profileProxy || $[13] !== setToast || $[14] !== setViewMode) {
    t5 = () => {
      if (!profileProxy.granted_to?.handle || !profileProxy.created_by?.handle) {
        return;
      }
      onProfileProxyModify({
        profileProxyId: profileProxy.id,
        grantedToHandle: profileProxy.granted_to.handle,
        createdByHandle: profileProxy.created_by.handle
      });
      setToast({
        message: "Action end time updated successfully!",
        type: "success"
      });
      setViewMode();
    };
    $[11] = onProfileProxyModify;
    $[12] = profileProxy;
    $[13] = setToast;
    $[14] = setViewMode;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== setToast) {
    t6 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[16] = setToast;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setSubmitting(false);
    };
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t8 = {
      mutationFn: t4,
      onSuccess: t5,
      onError: t6,
      onSettled: t7
    };
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const profileProxyActionCreditMutation = useMutation(t8);
  let t9;
  if ($[23] !== endTime || $[24] !== isEndTimeDisabled || $[25] !== profileProxyActionCreditMutation || $[26] !== requestAuth) {
    t9 = async () => {
      if (!endTime && !isEndTimeDisabled) {
        return;
      }
      setSubmitting(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setSubmitting(false);
        return;
      }
      await profileProxyActionCreditMutation.mutateAsync({
        end_time: isEndTimeDisabled ? null : endTime
      });
    };
    $[23] = endTime;
    $[24] = isEndTimeDisabled;
    $[25] = profileProxyActionCreditMutation;
    $[26] = requestAuth;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const onSubmit = t9;
  let t10;
  if ($[28] !== isEndTimeDisabled) {
    t10 = <div className="tw-mb-3 tw-w-full md:tw-w-auto"><ProxyCreateActionConfigEndTimeSwitch isActive={isEndTimeDisabled} setIsActive={setIsEndTimeDisabled} /></div>;
    $[28] = isEndTimeDisabled;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== isEndTimeDisabled || $[31] !== profileProxyAction.end_time) {
    t11 = !isEndTimeDisabled && <CommonTimeSelect currentTime={profileProxyAction.end_time} onMillis={setEndTime} disabled={isEndTimeDisabled} inline={true} size="sm" />;
    $[30] = isEndTimeDisabled;
    $[31] = profileProxyAction.end_time;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11) {
    t12 = <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-y-3 tw-gap-x-4 tw-w-full tw-h-full tw-items-center">{t10}{t11}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== setViewMode || $[37] !== submitting) {
    t13 = <button onClick={setViewMode} type="button" disabled={submitting} className="tw-w-full sm:tw-w-auto tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-800 hover:tw-bg-iron-700 tw-border tw-border-solid tw-border-iron-700 tw-text-iron-300 hover:tw-text-iron-50 focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out">Cancel</button>;
    $[36] = setViewMode;
    $[37] = submitting;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  const t14 = !isChangedAndValid || submitting;
  const t15 = `${!isChangedAndValid ? "tw-opacity-50" : "hover:tw-bg-primary-600 hover:tw-border-primary-600"} tw-w-full tw-flex tw-items-center tw-justify-center tw-relative tw-bg-primary-500 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-white tw-border tw-border-solid tw-border-primary-500 tw-rounded-lg tw-transition tw-duration-300 tw-ease-out`;
  let t16;
  if ($[39] !== submitting) {
    t16 = submitting && <CircleLoader size={CircleLoaderSize.SMALL} />;
    $[39] = submitting;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span>Update</span>;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t16) {
    t18 = <div className="tw-flex tw-items-center tw-space-x-2">{t16}{t17}</div>;
    $[42] = t16;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== onSubmit || $[45] !== t14 || $[46] !== t15 || $[47] !== t18) {
    t19 = <button onClick={onSubmit} disabled={t14} type="button" className={t15}>{t18}</button>;
    $[44] = onSubmit;
    $[45] = t14;
    $[46] = t15;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t13 || $[50] !== t19) {
    t20 = <div className="tw-mt-5 sm:tw-mt-8 md:tw-mt-0 tw-flex tw-items-center tw-justify-end md:tw-justify-start tw-gap-x-3">{t13}{t19}</div>;
    $[49] = t13;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t12 || $[53] !== t20) {
    t21 = <div><div className="tw-h-full tw-py-3 xl:tw-h-14 tw-rounded-lg tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-iron-600"><div className="tw-px-3 tw-w-full tw-h-full tw-flex tw-flex-col sm:tw-flex-row md:tw-items-center sm:tw-justify-between tw-gap-x-3">{t12}{t20}</div></div></div>;
    $[52] = t12;
    $[53] = t20;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  return t21;
}